// @ts-nocheck
import { useCallback } from 'react';
import axios from 'axios';

import API_ENDPOINTS from '../../const/ApiEndPoints';

export const getChangeRequestFieldOptions = () => {
  return axios
    .get(
      `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.MI.GET_CHANGE_REQUEST_FIELD_OPTIONS}`
    )
    .then((res) => res)
    .catch((err) => {
      throw err;
    });
};
export default function useChangeRequestImpact() {
  /**
   * This API will fetch the change request impact analysis details
   *
   * @param {string} entity_uuid - uuid of the entity.
   * @param {string} entity_type -  type of the entity.
   */
  const getChangeRequestImpactAnalysis = useCallback((params) => {
    return axios
      .get(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.MI.GET_IMPACT_ANALYSIS}`,
        { params, loader: false }
      )
      .then((res) => res)
      .catch((err) => {
        throw err;
      });
  }, []);

  return { getChangeRequestFieldOptions, getChangeRequestImpactAnalysis };
}
